import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import styles from "../LeftNavigation.module.scss";

import { generatePath, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../utils/Constant";
import { useSelector } from "react-redux";
import Add from "@mui/icons-material/Add";
import { useTeamFetcher } from "../../../../utils/TeamsFetcherHooks";
import TeamService from "../../../../service/TeamService";

const AddTeam = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // TODO: Fetch teams
  const teamsState = useSelector((state) => state.myTeams);
  const teams = useMemo(() => {
    return teamsState?.teams;
  }, [teamsState]);

  const { fetchMyTeamsAndUpdateStore } = useTeamFetcher();

  const onClick = useCallback(async () => {
    const bodyData = {
      name: `${t("team.team")} ${teams.length + 1}`,
    };

    const {
      data: {
        data: { id },
      },
    } = await TeamService.createTeam(bodyData);

    fetchMyTeamsAndUpdateStore();

    navigate(generatePath(ROUTES.TEAM_PROJECTS, { teamId: id }));
  }, [navigate, t, teams, fetchMyTeamsAndUpdateStore]);

  return (
    <div className={styles.actionContainer}>
      <div className={styles.actionItem} onClick={onClick}>
        <div className={styles.actionIcon}>
          <Add />
        </div>
        <span className={styles.display}>
          {t("navigation.create_new_team")}
        </span>
      </div>
    </div>
  );
};

export default AddTeam;
